import * as ActionTypes from '../actions/Actiontype';

const initState = {
  error: '',
  getEmployee: {},
  getstaticEmployee: {},
  Getstaticsingle: {},
};

const store = (state = initState, action) => {
  switch (action.type) {
    case ActionTypes.SEARCH_EMPLOYEE_INIT:
      return {
        ...state,
        error: '',
      };
    case ActionTypes.SEARCH_EMPLOYEE_SUCCESS:
      return {
        ...state,
        getEmployee: action?.payload,
      };
    case ActionTypes.SEARCH_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ActionTypes.GET_STATIC_EMPLOYEE_INIT:
      return {
        ...state,
        error: '',
      };
    case ActionTypes.GET_STATIC_EMPLOYEE_SUCCESS:
      return {
        ...state,
        getstaticEmployee: action?.payload,
      };
    case ActionTypes.GET_STATIC_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ActionTypes.GET_SINGLE_STATIC_EMPLOYEE_INIT:
      return {
        ...state,
        error: '',
      };
    case ActionTypes.GET_SINGLE_STATIC_EMPLOYEE_SUCCESS:
      return {
        ...state,
        Getstaticsingle: action?.payload,
      };
    case ActionTypes.GET_SINGLE_STATIC_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default store;
